import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {IssueStatusDTO} from "../domain/dtos/issue-status.dto";
import {IssueStatus} from "../domain/entities/issue-status.entity";
import {TransformerInterface} from "./transformerInterface";

@injectable()
@transformer({
    source: IssueStatus,
    target: `dto`
})
export class IssueStatusToDtoTransformer implements TransformerInterface<Partial<IssueStatusDTO>, IssueStatus> {

    public transform(issueStatus: IssueStatus): Promise<Partial<IssueStatusDTO>> {
        const dto: Partial<IssueStatusDTO> = issueStatus.isNew()
            ? {
                uid: issueStatus.uid,
                key: issueStatus.key,
                createdAt: issueStatus.createdAt.toUTC().toSQL()!,
                color: issueStatus.color,
                textColor: issueStatus.textColor,
                shortcut: issueStatus.shortcut,
                sorting: -1,
            }
            : Object.fromEntries(
                issueStatus.changedValues.map(propertyName => [propertyName, new Map(Object.entries(issueStatus)).get(`_${propertyName}`)!])
            );

        return Promise.resolve(dto);
    }

}
